/* TitanBanks — front-end effecten: scroll-reveal + tellende getallen. */
(function () {
  // Bewust NIET aan prefers-reduced-motion gekoppeld: browsers melden dit vals-positief (zie memory).
  var reduce = false;

  // ---- Scroll reveal ----
  var revealEls = document.querySelectorAll('.tb-reveal');
  if (!('IntersectionObserver' in window) || reduce) {
    revealEls.forEach(function (el) { el.classList.add('tb-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('tb-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  // ---- Count-up ----
  function formatNL(n) { return n.toLocaleString('nl-NL'); }
  function animateCount(el) {
    var target = parseInt((el.getAttribute('data-to') || el.textContent).replace(/\D/g, ''), 10);
    if (!target) return;
    if (reduce) { el.textContent = formatNL(target); return; }
    var dur = 1500, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = formatNL(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll('.tb-countup');
  if (counters.length) {
    if (!('IntersectionObserver' in window)) {
      counters.forEach(animateCount);
    } else {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { animateCount(e.target); io2.unobserve(e.target); }
        });
      }, { threshold: 0.2 });
      counters.forEach(function (el) { io2.observe(el); });
    }
  }
})();

/* Vector-lichtstrepen — diagonale glanzende lijnen met gloeiende staart (canvas, geen lib). */
(function () {
  // Bewust NIET aan prefers-reduced-motion gekoppeld: browsers melden dit vals-positief (zie memory).
  var reduce = false;
  var host = document.getElementById('tb-embers');
  if (!host || reduce) return;

  var canvas = document.createElement('canvas');
  canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;display:block;';
  host.appendChild(canvas);
  var ctx = canvas.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var W = 0, H = 0, streaks = [];
  var colors = ['#FF8C00', '#FFA53A', '#FF6A00'];
  var ang = -22 * Math.PI / 180;
  var dx = Math.cos(ang), dy = Math.sin(ang);

  function rand(a, b) { return a + Math.random() * (b - a); }
  function resize() {
    var r = host.getBoundingClientRect();
    W = canvas.width = Math.max(1, Math.round(r.width * dpr));
    H = canvas.height = Math.max(1, Math.round(r.height * dpr));
    canvas.style.width = r.width + 'px';
    canvas.style.height = r.height + 'px';
  }
  function spawn(initial) {
    return {
      x: initial ? rand(0, W) : rand(-0.15 * W, 0.15 * W),
      y: initial ? rand(0, H) : rand(0.25 * H, 1.15 * H),
      len: rand(50, 190) * dpr,
      w: rand(0.8, 2.4) * dpr,
      sp: rand(2.6, 8.5) * dpr,
      a: rand(0.25, 0.9),
      c: colors[Math.floor(Math.random() * colors.length)]
    };
  }
  resize();
  var N = Math.max(14, Math.round((W / dpr) / 52));
  for (var i = 0; i < N; i++) streaks.push(spawn(true));

  function frame() {
    ctx.clearRect(0, 0, W, H);
    ctx.globalCompositeOperation = 'lighter';
    ctx.lineCap = 'round';
    for (var i = 0; i < streaks.length; i++) {
      var s = streaks[i];
      s.x += dx * s.sp; s.y += dy * s.sp;
      var tx = s.x - dx * s.len, ty = s.y - dy * s.len;
      var g = ctx.createLinearGradient(tx, ty, s.x, s.y);
      g.addColorStop(0, 'rgba(255,140,0,0)');
      g.addColorStop(1, s.c);
      ctx.strokeStyle = g;
      ctx.lineWidth = s.w;
      ctx.globalAlpha = s.a;
      ctx.shadowColor = s.c;
      ctx.shadowBlur = 12 * dpr;
      ctx.beginPath();
      ctx.moveTo(tx, ty);
      ctx.lineTo(s.x, s.y);
      ctx.stroke();
      if (s.x - dx * s.len > W + 24 || s.y < -24) streaks[i] = spawn(false);
    }
    ctx.globalAlpha = 1; ctx.shadowBlur = 0; ctx.globalCompositeOperation = 'source-over';
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(resize, 200); });
})();

